import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';

export const TitleWrapper = styled.div`
  padding: 40px 30px 30px;
  border-bottom: 1px solid var(--cvna-color-grey-2);
  margin-bottom: 37px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${mediaQuery('s')} {
    padding: 42px 41px 30px;
    margin-bottom: 40px;
  }

  ${mediaQuery('m')} {
    flex-direction: row;
    &.financingPageTitle {
      flex-direction: column;
    }
  }

  &.has-subtitle {
    padding-bottom: 11px;

    ${mediaQuery('m')} {
      padding-bottom: 30px;
    }
  }
`;

export const Title = styled.div`
  font-size: 22px;
  line-height: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--cvna-color-blue-6);

  ${mediaQuery('s')} {
    font-size: 28px;
    line-height: 28px;
  }
`;
